import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;

import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';

import { Box, Button, ButtonDropdown, FlashbarProps, Form, FormField, Input, List, Modal, Select, SelectProps, SpaceBetween, SplitPanel, Table, TimeInput } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiAlertCircle, mdiAlertOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { differenceInCalendarDays, differenceInMinutes, format, isBefore, parse } from 'date-fns';
import { es } from 'date-fns/locale/es';
import DPModal from '../../../../../components/DPModal';
import EquipmentPicker from '../../../../../components/EquipmentPicker';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import SelectFlightType from '../../../../../components/selects/selectFlightTypes';
import SelectUser from '../../../../../components/selects/selectUser';
import UserPicker from '../../../../../components/UserPicker';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemAltitudes, ItemFlight, ItemFlightType } from '../../../../../resources/types';
import {
    addNotification,
    addNotificationStatus,
    buildBreadcrumbItems, getCookie, getEquipment, getUrlVersion, getUser, minutesToHHMM,
    setData,
    setLoading,
    setParameters
} from '../../../../commons/functions';
import { useStore } from '../../../store';



const pageSize = 10;
type OptionDefinition = SelectProps.Option;

type ItemFrequent = {
    id: string;
    text: string;
};
type ItemEquipment = {
    idEquipment: number;
    registration: string;
};
export const OPSFlightsAdd = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    //const storeAdmin = useStoreAdmin();

    const [keyw, setKeyw] = useState("");
    const [altitudes, setAltitudes] = useState<ItemAltitudes[]>([]);
    const [flightTypes, setFlightTypes] = useState<ItemFlightType[]>([]);
    const [altitude, setAltitude] = useState<ItemAltitudes>();


    const [userMessagesInvoicing, setUserMessagesInvoicing] = useState<FlashbarProps.MessageDefinition[]>([]);


    const [helpOpen, setHelpOpen] = useState(true);
    const [validFlight, setValidFlight] = useState(true);
    const [sideOpen, setSideOpen] = useState(false);
    const [modalOGN, setModalOGN] = useState(false);
    const [loadingOGN, setLoadingOGN] = useState(false);
    const [sideTarget, setSideTarget] = useState("flight");
    const [userPickerTarget, setUserPickerTarget] = useState("");
    const [userEquipmentTarget, setUserEquipmentTarget] = useState("");
    const [userPickerModal, setUserPickerModal] = useState(false);
    const [datePicker, setDatePicker] = useState(false);
    const [activeTab, setActiveTab] = useState("bydate");
    const [costValue, setCostValue] = useState("");

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    const [flight, setFlight] = useState<ItemFlight>({
        idFlight: 0,
        idUserPilot: 0,
        idUserInstructor: 0,
        idUserTow: 0,
        idEquipment: 0,
        idEquipmentTow: 0,
        departureTime: "",
        arrivalTime: "",
        arrivalTimeTow: "",
        obs: "",
        altitude: 0,
        idFlightType: 0,
        tacStart: 0,
        tacEnd: 0,
        ciclesLanding: 1,
    });
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [flightsOGN, setFlightsOGN] = useState<ItemFlight[]>([]);
    const [fPilots, setFPilots] = useState<ItemFrequent[]>([]);
    const [fPilotsTow, setFPilotsTow] = useState<ItemFrequent[]>([]);
    const [fPilotsInstructors, setFPilotsInstructors] = useState<ItemFrequent[]>([]);
    const [fEquipments, setFEquipments] = useState<ItemFrequent[]>([]);
    const [fEquipmentsTows, setFEquipmentsTows] = useState<ItemFrequent[]>([]);



    const [costOther, setCostOther] = useState("0");
    const [chargeOther, setChargeOther] = useState("0");
    const [chargeValue, setChargeValue] = useState("0");

    const resetFlight = {
        idFlight: 0,
        idUserPilot: 0,
        idUserInstructor: 0,
        idUserTow: 0,
        idEquipment: 0,
        idEquipmentTow: 0,
        departureTime: "",
        arrivalTime: "",
        arrivalTimeTow: "",
        obs: "",
        altitude: 0,
        idFlightType: 0,
        tacStart: 0,
        tacEnd: 0,
        ciclesLanding: 1,
    }
    const [showEquipmentPicker, setShowEquipmentPicker] = useState(false);

    useEffect(() => {
        if (flight) {

        }
    }, [flight]);
    useEffect(() => {
        handleRefresh();
    }, [parameters.date]);

    let tmpFlight: ItemFlight


    useEffect(() => {
        if (flights) {
            const uniquePilots: ItemFrequent[] = Array.from(
                new Map(
                    flights
                        .filter(flight => flight.equipmentType !== "TOW" && flight.idUserPilot !== 0) // ✅ filter first
                        .map(flight => [
                            flight.idUserPilot,
                            {
                                id: flight.idUserPilot.toString(),
                                text: flight.userPilot ?? ""
                            }
                        ])
                ).values()
            );
            setFPilots(uniquePilots)

            const uniquePilotsTow: ItemFrequent[] = Array.from(
                new Map(
                    flights
                        .filter(flight => flight.equipmentType === "TOW" && flight.idUserPilot !== 0) // ✅ filter first
                        .map(flight => [
                            flight.idUserPilot,
                            {
                                id: flight.idUserPilot.toString(),
                                text: flight.userPilot ?? ""
                            }
                        ])
                ).values()
            );
            setFPilotsTow(uniquePilotsTow)


            const uniquePilotsInstructors: ItemFrequent[] = Array.from(
                new Map(
                    flights
                        .filter(
                            flight =>
                                flight.equipmentType !== "TOW" && // exclude towing
                                flight.idUserInstructor != null &&
                                flight.idUserInstructor !== 0 && // exclude empty/invalid IDs
                                flight.userInstructor && flight.userInstructor.trim() !== "" // exclude blanks
                        )
                        .map(flight => [
                            flight.idUserInstructor,
                            {
                                id: flight.idUserInstructor ? flight.idUserInstructor.toString() : "0",
                                text: flight.userInstructor ?? "",
                            },
                        ])
                ).values()
            );
            setFPilotsInstructors(uniquePilotsInstructors)


            const uniqueEquipments: ItemFrequent[] = Array.from(
                new Map(
                    flights
                        .filter(
                            flight =>
                                flight.equipmentType !== "TOW" && // exclude towing
                                flight.idEquipment != null &&
                                flight.idEquipment !== 0 && // exclude empty/invalid IDs
                                flight.registration && flight.registration.trim() !== "" // exclude blanks
                        )
                        .map(flight => [
                            flight.idEquipment,
                            {
                                id: flight.idEquipment.toString(),
                                text: flight.registration ?? "",
                            },
                        ])
                ).values()
            );
            setFEquipments(uniqueEquipments)


            const uniqueEquipmentsTows: ItemFrequent[] = Array.from(
                new Map(
                    flights
                        .filter(
                            flight =>
                                flight.equipmentType === "TOW" && // exclude towing
                                flight.idEquipment != null &&
                                flight.idEquipment !== 0 && // exclude empty/invalid IDs
                                flight.registration && flight.registration.trim() !== "" // exclude blanks
                        )
                        .map(flight => [
                            flight.idEquipment,
                            {
                                id: flight.idEquipment.toString(),
                                text: flight.registration ?? "",
                            },
                        ])
                ).values()
            );
            setFEquipmentsTows(uniqueEquipmentsTows)
        } else {
            setFPilots([])
            setFPilotsTow([])
            setFPilotsInstructors([])
            setFEquipments([])
            setFEquipmentsTows([])
        }
    }, [flights]);
    useEffect(() => {
        let valid = true
        if (!(flight?.idEquipment !== undefined && flight.idEquipment > 0)) valid = false;
        if (!(flight?.idUserPilot !== undefined && flight.idUserPilot > 0)) valid = false;
        if (!(flight?.departureTime !== undefined && flight.departureTime.length == 5)) valid = false;
        if (!(flight?.arrivalTime !== undefined && flight.arrivalTime.length == 5)) valid = false;
        if ((flight && flight.altitude && flight.altitude > 0)) {
            if (!(flight?.idUserTow !== undefined && flight.idUserTow > 0)) valid = false;
            if (!(flight?.idEquipmentTow !== undefined && flight.idEquipmentTow > 0)) valid = false;
            if (!(flight?.arrivalTimeTow !== undefined && flight.arrivalTimeTow.length == 5)) valid = false;
        }
        if (altitudes && altitudes.length > 0) {
            if (flight && !flight.altitude) {
            }
        }
        if (!(flight?.idFlightType !== undefined && flight.idFlightType > 0)) valid = false;
        if (flight?.idFlightType !== undefined && flight.idFlightType > 0) {
            if (flight.idFlightType === 1133 || flight.idFlightType === 1135 || flight.idFlightType === 2799) {
                if (!(flight?.idUserInstructor !== undefined && flight.idUserInstructor > 0)) valid = false;
            }
        }
        setValidFlight(valid)
    }, [flight]);

    // Define it as a function that returns a string
    const tacTotalValue = (flight?.idEquipment > 0 && flight.tacStart != null && flight.tacEnd != null)
        ? (flight.tacEnd - flight.tacStart).toFixed(1)
        : "0.0";
    const handleHorometer = async (idEquipment: number) => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/horometer',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idEquipment: idEquipment }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.horometer) {
                    if (data.horometer.found)
                        setFlight(prev => ({ ...prev, tacStart: data.horometer.tacEnd, tacEnd: 0 }))
                    else
                        setFlight(prev => ({ ...prev, tacStart: 0, tacEnd: 0 }))
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const handleAddFlight = async () => {
        let body = handleFilterFlight()
        /*
        let body = {
            idFlight: 0,
            date: parameters.date,
            departureDate: parameters.date + " " + flight?.departureTime,
            arrivalDate: parameters.date + " " + flight?.arrivalTime,
            idEquipment: flight?.idEquipment,
            idUserPilot: flight?.idUserPilot,
            idFlightType: flight?.idFlightType,
            obs: flight?.obs,
            idUserInstructor: 0,
            idUserTow: 0,
            idEquipmentTow: 0,
            altitude: 0,
            arrivalDateTow: "",
            tacStart: flight?.tacStart,
            tacEnd: flight?.tacEnd,
            idAirportDeparture: 4712,
            idAirportArrival: 4712,
        }
        if (flight?.altitude && flight.idEquipmentTow && flight?.altitude > 0) {
            body.idUserTow = flight.idUserTow ?? 0
            body.idEquipmentTow = flight.idEquipmentTow
            body.altitude = flight.altitude
            body.arrivalDateTow = parameters.date + " " + flight?.arrivalTimeTow
        }
        if (flight?.idFlightType === 1135 || flight?.idFlightType === 1133 || flight?.idFlightType === 2799) {
            body.idUserInstructor = flight.idUserInstructor ?? 0
        }
            */
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/flights/add',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.flights) {
                    setFlights(data.flights)
                }
                setAltitudes([]), setAltitude(undefined); setFlight(resetFlight)
                //handleRefresh();
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }



    const handleRefreshOGN = async () => {


        try {
            setLoadingOGN(true)
            //console.log(format(parse(parameters.date, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'))
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/ogn',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    date: format(parse(parameters.date, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd'),
                    airfield: "SCLC",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setSideOpen(false)
                setFlightsOGN(data.flights)
                setModalOGN(true)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoadingOGN(false) }
    }

    const handleRefresh = async () => {
        try {
            if (parameters && parameters.date && parameters.date !== "") {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/flights/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        startDate: parameters.date,
                        endDate: parameters.date,
                        orderBy: "departureDate",
                        order: "desc",
                        orderBy2: "idTowingTo",
                        order2: "asc"
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setFlights(data.flights)
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    const filtered: ItemFlight[] = flights.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.userPilot, item.idFlight.toString(), item.userInstructor, item.flightType].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);
    const arrivalTimeRef = useRef<HTMLInputElement>(null);
    const departureTimeRef = useRef<HTMLInputElement>(null);
    const equipmentRef = useRef<HTMLInputElement>(null);
    const pilotRef = useRef<HTMLInputElement>(null);
    const ciclesLandingRef = useRef<HTMLInputElement>(null);




    function resetFlightTow() {
        setFlight((prev) => {
            if (!prev) return prev;
            return {
                ...prev,
                idEquipmentTow: 0,
                altitude: 0,
                arrivalTimeTow: "",
                idUserTow: 0,
            } as ItemFlight;
        });
    }
    function resetFlightGlobal() {
        setFlight(resetFlight);
    }

    const handleFilterFlight = () => {
        // Use curly braces {} for logic blocks
        let body: any = { ...flight };

        body.idAirportDeparture = 4712;
        body.idAirportArrival = 4712;
        body.date = parameters.date;
        if (body.altitude === 0) {
            body.idUserTow = 0;
            body.idEquipmentTow = 0;
            body.arrivalTimeTow = "";
            body.arrivalDateTow = ""
        } else {
            body.arrivalDateTow = `${parameters.date} ${body.arrivalTimeTow}`
        }
        if (body.idFlightType !== 1135 && body.idFlightType !== 1133 && body.idFlightType !== 2799) {
            body.idUserInstructor = 0;
        }
        if (body.timeCount !== "TAC") {
            delete body.tacStart;
            delete body.tacEnd;
        }
        body.arrivalDate = `${parameters.date} ${body.arrivalTime}`
        body.departureDate = `${parameters.date} ${body.departureTime}`


        //console.log(body)
        return body;
    };


    const proccesedFlights = flights.map((f: ItemFlight) => ({
        id: `f${f.idFlight}`,
        content: (<>
            <SpaceBetween direction='horizontal' size='xs'>
                <Box textAlign='left'>
                    <strong>{f.registration}</strong> <BadgeCustom color={f.bookingTypeBadge ?? "black"}>{f.flightType}</BadgeCustom>
                </Box>
                <Box textAlign='right'>{f.altitude && f.altitude > 0 ? `${f.altitude}m` : null}</Box>
            </SpaceBetween>
        </>),
        secondaryContent: `${f.departureTime} ${minutesToHHMM(f.delta ?? 0)}`,
        announcementLabel: `secondaryContent`
    }));
    const formatAviationDate = (dateStr: string): string => {
        const today = new Date();
        // Parse the custom Chilean format dd-MM-yyyy
        const parsedDate = parse(dateStr, 'dd-MM-yyyy', new Date());

        const diff = differenceInCalendarDays(today, parsedDate);

        // 1. Hoy
        if (diff === 0) {
            return `Hoy ${format(parsedDate, 'eeee', { locale: es })}`;
        }

        // 2. Ayer
        if (diff === 1) {
            return `Ayer ${format(parsedDate, 'eeee', { locale: es })}`;
        }

        // 3. Antes de ayer
        if (diff === 2) {
            return `Antes de ayer ${format(parsedDate, 'eeee', { locale: es })}`;
        }

        // 4. Case for specific days within the "Last week" logic
        // If it's between 3 and 7 days ago
        if (diff > 2 && diff <= 7) {
            return `${format(parsedDate, 'eeee', { locale: es })} pasado`;
        }

        // 5. Older dates
        return `Hace ${diff} días atrás`;
    };
    return (
        <CustomAppLayout
            toolsHide

            splitPanelOpen={flights.length > 0 && helpOpen}
            onSplitPanelToggle={(e) => setHelpOpen(e.detail.open)}

            splitPanelSize={300}
            splitPanel={


                <SplitPanel hidePreferencesButton header={`Vuelos ${parameters?.date}`}
                    closeBehavior={undefined}
                >
                    <SpaceBetween direction="vertical" size="xs">
                        <List items={proccesedFlights}
                            renderItem={item => item} />
                    </SpaceBetween>
                </SplitPanel>
            }

            contentType="form"
            breadcrumbs={
                < BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Header actions={<Favorites />}
                        description={
                            parameters.date && (
                                formatAviationDate(parameters.date)
                            )
                        }
                    //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                    >
                        Ingresar vuelo
                    </Header>
                    <div style={{ minWidth: 600 }}>

                        <SpaceBetween direction="vertical" size="xs">
                            <Form
                                header={
                                    <Header variant='h2' actions={
                                        parameters.date && flight && flight.idFlightType > 0 && (
                                            <Button loading={loadingOGN} onClick={() => handleRefreshOGN()}>OGN</Button>
                                        )}>

                                        <SpaceBetween direction='horizontal' size='xs'>
                                            <FormField label={"Fecha ingreso"}>

                                                <DPModal
                                                    date={parameters.date}
                                                    clear={true}
                                                    close={true}
                                                    end={new Date()}
                                                    today
                                                    onConfirm={(date) => {

                                                        const updatedParameters = {
                                                            ...parameters, // clone existing keys
                                                            date: (date) // add or update
                                                        };
                                                        setParameters(updatedParameters);
                                                    }}

                                                />
                                            </FormField>

                                            {flight && parameters.date && (
                                                <FormField label="Tipo de vuelo">

                                                    <SelectFlightType single onSelect={(detail) => {
                                                        //console.log(detail)
                                                        setFlight({ ...flight!, idFlightType: Number(detail) })
                                                        const nextInput = equipmentRef.current?.querySelector<HTMLInputElement>('input');
                                                        if (nextInput)
                                                            setTimeout(() => nextInput.focus(), 100);
                                                    }}
                                                        value={flight?.idFlightType}
                                                    />
                                                </FormField>
                                            )}
                                        </SpaceBetween>
                                    </Header>
                                }

                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Box float="right" key="action-buttons">
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Button disabled={!validFlight} onClick={() => handleAddFlight()} variant='primary'>Ingresar vuelo</Button>
                                            </SpaceBetween>
                                        </Box>

                                    </SpaceBetween>
                                }
                            >

                                {parameters.date && flight && flight.idFlightType > 0 && (
                                    <SpaceBetween direction='vertical' size='xs'>
                                        <SpaceBetween direction='horizontal' size='m'>
                                            <FormField
                                                label={
                                                    fEquipments && fEquipments.length > 0 ? (
                                                        <SpaceBetween direction='horizontal' size='xs'>
                                                            <span>Material</span>
                                                            <ButtonDropdown
                                                                items={fEquipments}
                                                                variant="inline-icon"
                                                                onItemClick={item => {
                                                                    const eq = getEquipment(Number(item.detail.id), data);
                                                                    //resetFlightGlobal();
                                                                    setTimeout(function () {

                                                                        setFlight((prev) => ({
                                                                            ...prev!,
                                                                            idEquipment: Number(eq.idEquipment),
                                                                            registration: eq.registration,
                                                                            groupTypeMasterCode: eq.groupTypeMasterCode,
                                                                            model: eq.make + "-" + eq.model,
                                                                            timeCount: eq.timeCount,
                                                                        }))

                                                                        const foundItem = data.equipments.find((item: { idEquipment: number; registration: string, jsonAltitudes: any }) => item.idEquipment === Number(eq.idEquipment));
                                                                        if (foundItem) {

                                                                            const mappedAltitudes: ItemAltitudes[] = foundItem.jsonAltitudes.map((altitude: ItemAltitudes) => ({
                                                                                altitude: altitude.altitude,
                                                                                label: String(altitude.altitude) + " metros",
                                                                                value: String(altitude.altitude),
                                                                            }));
                                                                            setAltitudes(mappedAltitudes);
                                                                            if (mappedAltitudes.length == 0)
                                                                                resetFlightTow();

                                                                        } else {
                                                                            setAltitudes([]);
                                                                            resetFlightTow();
                                                                        }
                                                                        handleHorometer(eq.idEquipment);

                                                                        const nextInput = pilotRef.current?.querySelector<HTMLInputElement>('input');
                                                                        if (nextInput)
                                                                            setTimeout(() => nextInput.focus(), 0);
                                                                    }, 100)
                                                                }}
                                                            />
                                                        </SpaceBetween>
                                                    ) : (
                                                        `Material`
                                                    )
                                                } constraintText={flight?.model}>
                                                <div style={{ width: 140 }} ref={equipmentRef}>
                                                    <SelectEquipment
                                                        value={flight?.idEquipment || 0}
                                                        onConfirm={(detail) => {
                                                            //resetFlightGlobal();
                                                            setTimeout(function () {
                                                                if (detail) {

                                                                    setFlight((prev) => ({
                                                                        ...prev!,
                                                                        idEquipment: Number(detail.idEquipment),
                                                                        registration: detail.registration,
                                                                        groupTypeMasterCode: detail.groupTypeMasterCode,
                                                                        model: detail.make + "-" + detail.model,
                                                                        timeCount: detail.timeCount,
                                                                    }))
                                                                    const foundItem = data.equipments.find((item: { idEquipment: number; registration: string, jsonAltitudes: any }) => item.idEquipment === Number(detail.idEquipment));
                                                                    if (foundItem) {

                                                                        const mappedAltitudes: ItemAltitudes[] = foundItem.jsonAltitudes.map((altitude: ItemAltitudes) => ({
                                                                            altitude: altitude.altitude,
                                                                            label: String(altitude.altitude) + " metros",
                                                                            value: String(altitude.altitude),
                                                                        }));
                                                                        setAltitudes(mappedAltitudes);
                                                                        if (mappedAltitudes.length == 0)
                                                                            resetFlightTow();

                                                                    } else {
                                                                        setAltitudes([]);
                                                                        resetFlightTow();
                                                                    }
                                                                    handleHorometer(detail.idEquipment)
                                                                } else {
                                                                    setAltitudes([])
                                                                    if (flight && flight.idEquipment && flight.registration && flight.model) {
                                                                        setFlight((prev) => {
                                                                            if (!prev) return prev;
                                                                            const { registration, model, ...rest } = prev; // remove only these
                                                                            return {
                                                                                ...rest,
                                                                                idEquipment: 0, // explicitly reset to 0
                                                                            };
                                                                        });
                                                                    }
                                                                }
                                                                const nextInput = pilotRef.current?.querySelector<HTMLInputElement>('input');
                                                                if (nextInput)
                                                                    setTimeout(() => nextInput.focus(), 0);
                                                            }, 100)
                                                        }} />
                                                </div>
                                            </FormField>
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <FormField
                                                    label={
                                                        fPilots && fPilots.length > 0 ? (
                                                            <SpaceBetween direction='horizontal' size='xs'>
                                                                <span>Piloto</span>
                                                                <ButtonDropdown
                                                                    items={fPilots}
                                                                    variant="inline-icon"
                                                                    onItemClick={item => {
                                                                        const user = getUser(Number(item.detail.id), data)
                                                                        if (flight) {
                                                                            setFlight((prev) => ({
                                                                                ...prev!,
                                                                                idUserPilot: user?.idUser || 0,
                                                                                userPilot: user?.displayName || "",
                                                                            }))
                                                                            const nextInput = departureTimeRef.current?.querySelector<HTMLInputElement>('input');
                                                                            if (nextInput)
                                                                                setTimeout(() => nextInput.focus(), 0);
                                                                        }
                                                                    }}
                                                                />
                                                            </SpaceBetween>
                                                        ) : (
                                                            "Piloto"
                                                        )
                                                    }
                                                >
                                                    <div style={{ width: 200 }} ref={pilotRef}>
                                                        <SelectUser
                                                            value={flight?.idUserPilot}
                                                            onConfirm={(detail) => {
                                                                if (!flight) return
                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    idUserPilot: Number(detail?.idUser),
                                                                    userPilot: detail?.displayName || "",
                                                                }))
                                                                console.log("SelectUser")
                                                                const nextInput = departureTimeRef.current?.querySelector<HTMLInputElement>('input');
                                                                console.log(nextInput)
                                                                if (nextInput)
                                                                    setTimeout(() => nextInput.focus(), 0);
                                                            }} />

                                                    </div>
                                                </FormField>
                                                <div style={{ float: "right" }}>
                                                    <FormField label="Aterrizajes">
                                                        <div style={{ width: 100 }}>
                                                            <Input
                                                                disabled={!(flight.timeCount && flight.timeCount === 'TAC')}
                                                                autoComplete={false}
                                                                onChange={(event) => {
                                                                    console.log(event.detail)
                                                                    console.log({
                                                                        ...flight!,
                                                                        ciclesLanding: parseInt(event.detail.value)
                                                                    })
                                                                    setFlight((prev) => ({
                                                                        ...prev!,
                                                                        ciclesLanding: parseInt(event.detail.value)
                                                                    }))
                                                                }}
                                                                type="number"
                                                                placeholder='X'
                                                                value={flight?.ciclesLanding.toString()} />
                                                        </div>
                                                    </FormField>
                                                </div>
                                            </SpaceBetween>
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <FormField label="Hora salida">
                                                    <div style={{ width: 100 }} ref={departureTimeRef}
                                                        onKeyDown={(event) => {
                                                            console.log(event.key)
                                                            if (event.key.toLocaleLowerCase() === "enter") {
                                                                const nextInput = arrivalTimeRef.current?.querySelector<HTMLInputElement>('input');
                                                                if (nextInput)
                                                                    nextInput.focus();
                                                            }
                                                        }}>
                                                        <TimeInput

                                                            disabled={flight && flight.idEquipment === 0}
                                                            autoComplete={false}
                                                            onChange={(event) =>
                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    departureTime: event.detail.value
                                                                }))}
                                                            format="hh:mm"
                                                            placeholder='00:00'
                                                            value={flight?.departureTime ?? ""} />
                                                    </div>
                                                </FormField>

                                                <FormField label="Horómetro Ini">
                                                    <div style={{ width: 100 }}>
                                                        <Input
                                                            disabled={!(flight.timeCount && flight.timeCount === 'TAC')}
                                                            autoComplete={false}
                                                            onChange={(event) =>
                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    tacStart: parseFloat(event.detail.value)
                                                                }))}
                                                            type="number"
                                                            placeholder='123.45'
                                                            value={flight?.tacStart ? flight?.tacStart.toString() : "0"} />
                                                    </div>
                                                </FormField>
                                            </SpaceBetween>
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <FormField label="Hora llegada">
                                                    <div style={{ width: 100 }} ref={arrivalTimeRef}>
                                                        <TimeInput
                                                            key={"departureTime"}
                                                            disabled={(flight && flight.idEquipment === 0) || flight.departureTime.length !== 5}
                                                            autoComplete={false}
                                                            onChange={(event) => {
                                                                if (event.detail.value.length === 5) {
                                                                    if (!isBefore(
                                                                        parse(flight.departureTime, "HH:mm", new Date()), parse(event.detail.value, "HH:mm", new Date())
                                                                    )) {
                                                                        return;
                                                                    }
                                                                }
                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    arrivalTime: event.detail.value
                                                                }))
                                                            }}
                                                            format="hh:mm"
                                                            placeholder='00:00'
                                                            value={flight?.arrivalTime ?? ""} />
                                                    </div>
                                                </FormField>

                                                <FormField label="Horómetro Fin">
                                                    <div style={{ width: 100 }}>
                                                        <Input
                                                            disabled={!(flight.timeCount && flight.timeCount === 'TAC')}
                                                            autoComplete={false}
                                                            onChange={(event) =>
                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    tacEnd: parseFloat(event.detail.value)
                                                                }))}
                                                            type="number"
                                                            placeholder='123.45'
                                                            value={flight?.tacEnd ? flight?.tacEnd.toString() : "0"} />
                                                    </div>
                                                </FormField>
                                            </SpaceBetween>
                                            <SpaceBetween direction='vertical' size='xs'>
                                                <FormField label="Tiempo">
                                                    <div style={{ width: 100 }}>
                                                        <Input

                                                            value={
                                                                flight && flight.departureTime && flight.arrivalTime && flight.departureTime.length == 5 && flight.arrivalTime.length == 5 ?
                                                                    minutesToHHMM(differenceInMinutes(parse(flight.arrivalTime, "HH:mm", new Date()), parse(flight.departureTime, "HH:mm", new Date())))
                                                                    : ""

                                                            } autoComplete={false} readOnly />
                                                    </div>
                                                </FormField>


                                                <FormField label="Total" info={Number(tacTotalValue) <= 0 && flight.timeCount && flight.timeCount === 'TAC' ? <Icon path={mdiAlertCircle} size={0.75} color="red" /> : Number(tacTotalValue) >= 4 ? <Icon path={mdiAlert} size={0.75} color="orange" /> : null}>
                                                    <div style={{ width: 100 }}>
                                                        <Input
                                                            disabled={!(flight.timeCount && flight.timeCount === 'TAC')}
                                                            autoComplete={false}
                                                            readOnly
                                                            type="number"
                                                            placeholder='123.4'
                                                            value={tacTotalValue} />
                                                    </div>
                                                </FormField>
                                            </SpaceBetween>

                                        </SpaceBetween>
                                        {!!flight && (
                                            <SpaceBetween direction='horizontal' size='m'>
                                                <FormField
                                                    label={
                                                        flight && fEquipmentsTows.length > 0 ? (
                                                            <SpaceBetween direction='horizontal' size='xs'>
                                                                <span>Remolcador</span>
                                                                <ButtonDropdown
                                                                    disabled={!(altitudes.length > 0 && !!flight.altitude && flight.altitude > 0)}
                                                                    items={fEquipmentsTows}
                                                                    variant="inline-icon"
                                                                    onItemClick={item => {
                                                                        const eq = getEquipment(Number(item.detail.id), data)
                                                                        if (flight) {
                                                                            setFlight((prev) => ({
                                                                                ...prev!,
                                                                                idEquipmentTow: eq.idEquipment,
                                                                                registrationTow: eq.registration || "",
                                                                            }))
                                                                        }
                                                                    }}
                                                                />
                                                            </SpaceBetween>
                                                        ) : (
                                                            "Remolcador"
                                                        )
                                                    } constraintText={flight.modelTow}>
                                                    <div style={{ width: 140 }}>
                                                        <SelectEquipment
                                                            disabled={!(altitudes.length > 0 && !!flight.altitude && flight.altitude > 0)}

                                                            idCategory={911557}
                                                            value={flight?.idEquipmentTow || 0}
                                                            onConfirm={(detail) => {
                                                                if (detail) {
                                                                    setFlight((prev) => ({
                                                                        ...prev!,
                                                                        idEquipmentTow: Number(detail.idEquipment),
                                                                        registrationTow: detail.registration,
                                                                    }))
                                                                } else {
                                                                    setFlight((prev) => {
                                                                        if (!prev) return prev;

                                                                        const { idEquipmentTow, registrationTow, ...rest } = prev; // omit these keys
                                                                        return rest; // return the remaining keys
                                                                    });
                                                                }
                                                            }} />
                                                    </div>
                                                </FormField>
                                                <FormField

                                                    label={
                                                        flight && flight.idEquipment > 0 && fPilotsTow.length > 0 ? (
                                                            <SpaceBetween direction='horizontal' size='xs'>
                                                                <span>Piloto remocaldor</span>
                                                                <ButtonDropdown
                                                                    disabled={!(altitudes.length > 0 && !!flight.altitude && flight.altitude > 0)}
                                                                    items={fPilotsTow}
                                                                    variant="inline-icon"
                                                                    onItemClick={item => {
                                                                        const user = getUser(Number(item.detail.id), data)
                                                                        if (flight) {
                                                                            setFlight((prev) => ({
                                                                                ...prev!,
                                                                                idUserTow: user?.idUser || 0,
                                                                                userTow: user?.displayName || "",
                                                                            }))
                                                                        }
                                                                    }}
                                                                />
                                                            </SpaceBetween>
                                                        ) : (
                                                            "Piloto remocaldor"
                                                        )
                                                    }>

                                                    <div style={{ width: 200 }}>
                                                        <SelectUser
                                                            disabled={!(altitudes.length > 0 && !!flight.altitude && flight.altitude > 0)}
                                                            value={flight?.idUserTow}
                                                            filter={`TOWING`}
                                                            onConfirm={(detail) => {
                                                                if (!flight) return

                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    idUserTow: Number(detail?.idUser),
                                                                    userTow: detail?.displayName || "",
                                                                }))
                                                            }} />
                                                    </div>
                                                </FormField>
                                                <div style={{ width: 100 }}>

                                                    <FormField label="Remolque">
                                                        <Select
                                                            disabled={!(altitudes.length > 1)}
                                                            placeholder="Seleccione"
                                                            expandToViewport={true}
                                                            selectedOption={altitude ?? null}
                                                            onChange={({ detail }) => {
                                                                if (Number(detail.selectedOption.value) === 0) {
                                                                    setFlight({ ...flight!, altitude: Number(detail.selectedOption.value) });
                                                                } else {
                                                                    setFlight({ ...flight!, altitude: Number(detail.selectedOption.value) });
                                                                }
                                                                setAltitude(detail.selectedOption as ItemAltitudes);
                                                            }}
                                                            options={[{ altitude: 0, value: "", label: "Sin remolque" },
                                                            ...altitudes
                                                            ]}
                                                        />
                                                    </FormField>
                                                </div>
                                                <FormField label="Hora llegada">
                                                    <div style={{ width: 100 }}>
                                                        <TimeInput


                                                            disabled={(!(altitudes.length > 0 && !!flight.altitude && flight.altitude > 0) || flight.departureTime.length !== 5)}
                                                            onChange={(event) => {

                                                                if (event.detail.value.length === 5) {
                                                                    if (!isBefore(
                                                                        parse(flight.departureTime, "HH:mm", new Date()), parse(event.detail.value, "HH:mm", new Date())
                                                                    )) {
                                                                        return;
                                                                    }
                                                                }
                                                                setFlight((prev) => ({
                                                                    ...prev!,
                                                                    arrivalTimeTow: event.detail.value
                                                                }))
                                                            }}
                                                            format="hh:mm"
                                                            placeholder='00:00'
                                                            value={flight?.arrivalTimeTow ?? ""} />
                                                    </div>
                                                </FormField>
                                                <FormField label="Tiempo">
                                                    <div style={{ width: 100 }}>
                                                        <Input

                                                            disabled={!(altitudes.length > 0 && !!flight.altitude && flight.altitude > 0)}
                                                            value={
                                                                flight.departureTime && flight.arrivalTimeTow && flight.departureTime.length == 5 && flight.arrivalTimeTow.length == 5 ?
                                                                    minutesToHHMM(differenceInMinutes(parse(flight.arrivalTimeTow, "HH:mm", new Date()), parse(flight.departureTime, "HH:mm", new Date())))
                                                                    : ""

                                                            } autoComplete={false} readOnly />
                                                    </div>
                                                </FormField>

                                            </SpaceBetween>
                                        )}
                                        <SpaceBetween direction='horizontal' size='xs'>


                                            <FormField

                                                label={
                                                    flight && flight?.idEquipment > 0 && fPilotsInstructors.length > 0 ? (
                                                        <SpaceBetween direction='horizontal' size='xs'>
                                                            <span>Piloto instructor</span>
                                                            <ButtonDropdown
                                                                disabled={!(flight && flight.idEquipment > 0 && (flight.idFlightType == 1135 || flight.idFlightType == 1133 || flight.idFlightType == 2799))}
                                                                items={fPilotsInstructors}
                                                                variant="inline-icon"
                                                                onItemClick={item => {
                                                                    const user = getUser(Number(item.detail.id), data)
                                                                    if (flight) {
                                                                        setFlight((prev) => ({
                                                                            ...prev!,
                                                                            idUserInstructor: user?.idUser || 0,
                                                                            userInstructor: user?.displayName || "",
                                                                        }))
                                                                    }
                                                                }}
                                                            />
                                                        </SpaceBetween>
                                                    ) : (
                                                        "Piloto instructor"
                                                    )
                                                }>
                                                <SelectUser
                                                    value={flight?.idUserInstructor}
                                                    disabled={!(flight && flight.idEquipment > 0 && (flight.idFlightType == 1135 || flight.idFlightType == 1133 || flight.idFlightType == 2799))}
                                                    filter={`INSTRUCTOR.${flight.groupTypeMasterCode}`}
                                                    onConfirm={(detail) => {

                                                        if (!flight) return
                                                        setFlight((prev) => ({
                                                            ...prev!,
                                                            idUserInstructor: Number(detail?.idUser),
                                                            userInstructor: detail?.displayName || "",
                                                        }))
                                                    }} />
                                            </FormField>

                                            <FormField label="Observaciones">
                                                <Input value={flight?.obs ?? ""} onChange={(event) => setFlight({ ...flight!, obs: event.detail.value })} />
                                            </FormField>
                                        </SpaceBetween>
                                    </SpaceBetween>
                                )}
                            </Form>
                        </SpaceBetween>

                    </div>
                    <Modal header={<Header>Seleccionar Vuelo OGN</Header>} visible={modalOGN} size="large" onDismiss={() => setModalOGN(false)}>
                        <Table
                            onRowClick={({ detail }) => {
                                let eq = getEquipment(Number(detail.item.idEquipment), data)
                                let eqT = getEquipment(Number(detail.item.idEquipmentTow), data)
                                let eqMake = ""
                                if (eq) {
                                    eqMake = eq.make + "-" + eq.model;
                                }

                                let eqMakeTow = ""
                                if (eqT) {
                                    eqMakeTow = eqT.make + "-" + eqT.model;
                                }
                                const d = detail.item;
                                if (!(d.idEquipment && d.registration && eq.groupTypeMasterCode && d.idEquipmentTow && d.registrationTow && d.departureTime && d.arrivalTime && d.arrivalTimeTow && d.altitude))
                                    return;

                                setFlight((prev) => ({
                                    ...prev!,
                                    idEquipment: Number(detail.item.idEquipment),
                                    registration: detail.item.registration,
                                    groupTypeMasterCode: eq.groupTypeMasterCode,
                                    idEquipmentTow: Number(detail.item.idEquipmentTow),
                                    registrationTow: detail.item.registrationTow,
                                    departureTime: detail.item.departureTime,
                                    arrivalTime: detail.item.arrivalTime,
                                    arrivalTimeTow: detail.item.arrivalTimeTow,
                                    altitude: detail.item.altitude,
                                    model: eqMake,
                                    modelTow: eqMakeTow,
                                }))
                                /*
                                                                setFlight({
                                                                    ...flight!,
                                                                    idEquipment: Number(detail.item.idEquipment),
                                                                    registration: detail.item.registration,
                                                                    idEquipmentTow: Number(detail.item.idEquipmentTow),
                                                                    registrationTow: detail.item.registrationTow,
                                                                    departureTime: detail.item.departureTime,
                                                                    arrivalTime: detail.item.arrivalTime,
                                                                    arrivalTimeTow: detail.item.arrivalTimeTow,
                                                                    altitude: detail.item.altitude, 
                                                                });
                                */
                                const foundItem = data.equipments.find((item: { idEquipment: number; registration: string, jsonAltitudes: any }) => item.idEquipment === Number(detail.item.idEquipment));
                                const mappedAltitudes: ItemAltitudes[] = foundItem.jsonAltitudes.map((altitude: ItemAltitudes) => ({
                                    altitude: altitude.altitude,
                                    label: String(altitude.altitude) + " metros",
                                    value: String(altitude.altitude),
                                }));
                                setAltitudes(mappedAltitudes);
                                setAltitude({ label: `${detail.item.altitude} metros`, value: detail.item.altitude ? detail.item.altitude.toString() : "0", altitude: detail.item.altitude ?? 0 })
                                setModalOGN(false)
                                //detail.item.altitude.toString())
                            }}
                            stickyHeader
                            columnDefinitions={[
                                {
                                    id: "idEquipmentTmp",
                                    header: "Equipo",
                                    cell: item => {
                                        const isValid =
                                            item.idEquipment > 0 &&
                                            item.registration !== "" &&
                                            item.idEquipmentTow &&
                                            item.idEquipmentTow > 0 &&
                                            item.registrationTow &&
                                            item.departureTime &&
                                            item.departureTime !== "" &&
                                            item.arrivalTime &&
                                            item.arrivalTime !== "" &&
                                            item.arrivalTimeTow &&
                                            item.arrivalTimeTow !== "" &&
                                            item.altitude &&
                                            item.altitude > 0;
                                        return (
                                            <span>
                                                {item.registration}
                                                {!isValid && <Icon path={mdiAlertOutline} size={1} color="red" />}
                                            </span>
                                        );
                                    },
                                    width: 120
                                },
                                {
                                    id: "altitudeTmp",
                                    header: "Altura",
                                    cell: item => item.altitude,
                                    width: 120
                                },
                                {
                                    id: "departureDateTmp",
                                    header: "Salida",
                                    cell: item => item.departureTime,
                                    width: 160
                                },
                                {
                                    id: "departureTimeTmp",
                                    header: "Llegada",
                                    cell: item => item.arrivalTime,
                                    width: 120
                                },
                                {
                                    id: "idUser2Tmp",
                                    header: "Remolque",
                                    cell: item => item.registrationTow
                                },
                                {
                                    id: "idUser3Tmp",
                                    header: "Llegada",
                                    cell: item => item.arrivalTimeTow
                                },
                            ]}
                            trackBy="id"
                            items={flightsOGN ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin vuelos en fecha seleccionada</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                    </Modal>
                    <UserPicker
                        visible={userPickerModal}
                        clear={false}
                        close={false}
                        onDismiss={() => {
                            setUserPickerModal(false)
                        }}

                        onConfirm={(user) => {
                            if (!flight) return;
                            if (userPickerTarget === "idUser") {
                                setFlight({ ...flight, idUserPilot: Number(user.value), userPilot: user.label, });
                            }
                            if (userPickerTarget === "idUserPilot") {
                                setFlight({ ...flight, idUserPilot: Number(user.value), userPilot: user.label, });
                            }
                            if (userPickerTarget === "idUserTow") {
                                setFlight({ ...flight, idUserTow: Number(user.value), userTow: user.label, });
                            }
                            if (userPickerTarget === "idUserInstructor") {
                                setFlight({ ...flight, idUserInstructor: Number(user.value), userInstructor: user.label, });
                            }
                            setUserPickerModal(false);
                        }}

                    />

                    <EquipmentPicker
                        visible={showEquipmentPicker}
                        clear={false}
                        close={false}
                        //isBookCapable={1}
                        onDismiss={() => {
                            setShowEquipmentPicker(false)
                        }}
                        onConfirm={(equipment) => {
                            const foundItem = data.equipments.find((item: { idEquipment: number; registration: string, jsonAltitudes: any }) => item.idEquipment === Number(equipment));

                            if (foundItem) {
                                if (userEquipmentTarget === "idEquipment") {

                                    const mappedAltitudes: ItemAltitudes[] = foundItem.jsonAltitudes.map((altitude: ItemAltitudes) => ({
                                        altitude: altitude.altitude,
                                        label: String(altitude.altitude) + " metros",
                                        value: String(altitude.altitude),
                                    }));
                                    setAltitudes(mappedAltitudes);
                                    setFlight({ ...flight!, idEquipment: Number(equipment), registration: foundItem.registration });
                                }

                                if (userEquipmentTarget === "idEquipmentTow") {

                                    setFlight({ ...flight!, idEquipmentTow: Number(equipment), registrationTow: foundItem.registration });
                                }
                            }


                            const updatedParameters = {
                                ...parameters, // clone existing keys
                                idEquipment: Number(equipment) // add or update
                            };

                            setParameters(updatedParameters); // updates state + storage
                            setShowEquipmentPicker(false);
                        }}

                    />
                </>
            }
        />
    );
};
